<template>
    <KpTooltip :max-width="maxWidth">
        <template #activator="{ on }">
            <span>
                <KpIcon :size="iconSize" :icon-cls="iconCls" color="tooltip" v-on="on" />
            </span>
        </template>
        <span v-if="text">{{ text }}</span>
        <span v-if="html" v-html="html"></span>
    </KpTooltip>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null,
        },
        html: {
            type: String,
            default: null,
        },
        maxWidth: {
            type: String,
            default: '350px',
        },
        iconCls: {
            type: String,
            default: 'support',
        },
        iconSize: {
            type: [String, Number],
            default: '16',
        },
    },
};
</script>
